import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import sh from "bundles/common/utils/sh";
import TimeProjectTable from "./TimeProjectTable";

const TimeProjectIndexPage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({});

  const fetchProjects = useCallback(() => {
    setLoading(true);
    const params = { page, limit: perPage };
    if (searchQuery) params.query = searchQuery;
    if (filters.companyId) params.company_id = filters.companyId;
    if (filters.profilePipelineId) params.profile_pipeline_id = filters.profilePipelineId;
    if (filters.internalUserId) params.internal_user_id = filters.internalUserId;
    if (filters.fromDate) params.from_date = filters.fromDate;
    if (filters.toDate) params.to_date = filters.toDate;

    sh.get("/internal/search/project_time_stats", { params })
      .then((res) => {
        setProjects(res.data?.data || []);
        setTotalCount(res.data?.pagy?.count || 0);
      })
      .catch(() => {
        enqueueSnackbar("Failed to fetch project time stats", { variant: "error" });
      })
      .finally(() => setLoading(false));
  }, [page, perPage, searchQuery, filters, enqueueSnackbar]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #F9FAFF 0%, #EEF0F6 100%)",
      }}
    >
      <TimeProjectTable
        rows={projects}
        onQueryChange={(q) => { setSearchQuery(q); setPage(1); }}
        filters={filters}
        onFiltersChange={(f) => { setFilters(f); setPage(1); }}
        page={page}
        totalCount={totalCount}
        rowsPerPage={perPage}
        onPageChange={setPage}
        onRowsPerPageChange={(val) => { setPerPage(val); setPage(1); }}
        loading={loading}
        onRowClick={(row) => navigate(`/internal/time-project/${row.id}`)}
      />
    </Box>
  );
};

export default TimeProjectIndexPage;
